import { Link } from "react-router-dom";

const articleCards = [
  {
    type: "internal",
    to: "/hoobuyspreadsheet",
    img: "https://readdy.ai/api/search-image?query=Clean%20workspace%20with%20laptop%20displaying%20an%20organized%20spreadsheet%20interface%2C%20warm%20natural%20daylight%2C%20a%20small%20notebook%20and%20pen%20beside%20the%20laptop%2C%20minimalist%20desk%20setup%2C%20neutral%20cream%20and%20soft%20beige%20tones%2C%20editorial%20photography&width=600&height=400&seq=seo-card-v2-guia-completo&orientation=landscape",
    title: "Guia Completo Hoobuy Spreadsheet 2026",
    subtitle: "Tutorial Completo",
  },
  {
    type: "internal",
    to: "/guia-iniciantes-hoobuy",
    img: "https://readdy.ai/api/search-image?query=Bright%20clean%20desk%20with%20an%20open%20laptop%20beside%20a%20notebook%20and%20coffee%20cup%2C%20morning%20sunlight%20streaming%20through%20window%2C%20fresh%20start%20concept%2C%20warm%20cream%20and%20soft%20green%20accents%2C%20clean%20composition&width=600&height=400&seq=seo-card-v2-iniciantes&orientation=landscape",
    title: "Hoobuy Spreadsheet para Iniciantes",
    subtitle: "Passo a Passo 2026",
  },
  {
    type: "internal",
    to: "/verificar-links-hoobuy",
    img: "https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20holding%20smartphone%20with%20verification%20checklist%20on%20screen%2C%20laptop%20in%20background%2C%20security%20concept%2C%20warm%20desk%20lamp%20lighting%2C%20neutral%20cream%20tones&width=600&height=400&seq=seo-card-v2-verificar&orientation=landscape",
    title: "Como Verificar Links no Hoobuy Spreadsheet",
    subtitle: "Guia de Segurança",
  },
  {
    type: "internal",
    to: "/top-produtos-hoobuy-2026",
    img: "https://readdy.ai/api/search-image?query=Aesthetic%20flat%20lay%20of%20trendy%20fashion%20items%20sneakers%20watch%20sunglasses%20on%20warm%20terracotta%20surface%2C%20golden%20hour%20lighting%2C%20editorial%20product%20photography%2C%20warm%20amber%20tones&width=600&height=400&seq=seo-card-v2-top-produtos&orientation=landscape",
    title: "Top 10 Produtos Hoobuy Spreadsheet",
    subtitle: "Mais Vendidos 2026",
  },
  {
    type: "internal",
    to: "/comparacao-agentes-hoobuy",
    img: "https://readdy.ai/api/search-image?query=Split%20screen%20concept%20showing%20two%20minimalist%20workspaces%20side%20by%20side%2C%20each%20with%20different%20interface%20designs%2C%20comparison%20theme%2C%20warm%20lighting%2C%20clean%20neutral%20background&width=600&height=400&seq=seo-card-v2-comparacao&orientation=landscape",
    title: "Hoobuy vs Outros Agentes 2026",
    subtitle: "Comparação Completa",
  },
  {
    type: "internal",
    to: "/guia-tamanhos-hoobuy",
    img: "https://readdy.ai/api/search-image?query=Measuring%20tape%20wrapped%20around%20a%20folded%20garment%20on%20wooden%20table%20with%20size%20chart%20notebook%2C%20fashion%20design%20studio%2C%20warm%20natural%20lighting%2C%20neutral%20cream%20and%20brown%20tones&width=600&height=400&seq=seo-card-v2-tamanhos&orientation=landscape",
    title: "Guia de Tamanhos no Hoobuy",
    subtitle: "Nunca Mais Erre",
  },
  {
    type: "internal",
    to: "/erros-comuns-hoobuy",
    img: "https://readdy.ai/api/search-image?query=Red%20paper%20warning%20sign%20on%20desk%20surrounded%20by%20shopping%20items%20packages%20and%20receipts%2C%20warm%20ambient%20lighting%2C%20conceptual%20still%20life%2C%20neutral%20cream%20background&width=600&height=400&seq=seo-card-v2-erros&orientation=landscape",
    title: "7 Erros Comuns no Hoobuy Spreadsheet",
    subtitle: "Como Evitar",
  },
  {
    type: "internal",
    to: "/dicas-envio-internacional",
    img: "https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20surrounded%20by%20packing%20materials%20and%20a%20world%20map%20on%20wooden%20desk%2C%20global%20shipping%20concept%2C%20warm%20lighting%2C%20neutral%20cream%20and%20brown%20tones&width=600&height=400&seq=seo-card-v2-envio&orientation=landscape",
    title: "Dicas de Envio Internacional Hoobuy",
    subtitle: "Economize no Frete",
  },
  {
    type: "internal",
    to: "/faq-hoobuy-spreadsheet",
    img: "https://readdy.ai/api/search-image?query=Colorful%20sticky%20notes%20with%20question%20marks%20on%20monitor%20screen%2C%20pen%20and%20notebook%2C%20bright%20daylight%2C%20help%20desk%20concept%2C%20warm%20cream%20and%20yellow%20accents&width=600&height=400&seq=seo-card-v2-faq&orientation=landscape",
    title: "FAQ Hoobuy Spreadsheet 2026",
    subtitle: "Respostas Completas",
  },
  {
    type: "external",
    href: "https://kaspreadsheet.com",
    img: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20a%20spreadsheet%20printout%20on%20desk%20with%20green%20checkmark%20stamp%2C%20trust%20and%20verification%20concept%2C%20warm%20natural%20light%2C%20clean%20composition%2C%20neutral%20tones&width=600&height=400&seq=seo-card-v2-confiavel&orientation=landscape",
    title: "Hoobuy Spreadsheet é Confiável?",
    subtitle: "Análise 2026",
  },
  {
    type: "external",
    href: "https://kaspreadsheet.com",
    img: "https://readdy.ai/api/search-image?query=Two%20minimalist%20product%20groups%20side%20by%20side%20on%20clean%20surface%20with%20rating%20stars%2C%20comparison%20concept%2C%20warm%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20style&width=600&height=400&seq=seo-card-v2-melhor-china&orientation=landscape",
    title: "Melhor Spreadsheet China 2026",
    subtitle: "Review Atualizado",
  },
  {
    type: "internal",
    to: "/historias-sucesso-hoobuy",
    img: "https://readdy.ai/api/search-image?query=Happy%20person%20unboxing%20a%20package%20at%20home%20with%20genuine%20excitement%2C%20natural%20window%20light%2C%20cozy%20living%20room%2C%20authentic%20moment%2C%20warm%20cream%20and%20soft%20brown%20interior&width=600&height=400&seq=seo-card-v2-historias&orientation=landscape",
    title: "Histórias de Sucesso Hoobuy",
    subtitle: "Resultados Reais",
  },
  {
    type: "external",
    href: "https://kaspreadsheet.com",
    img: "https://readdy.ai/api/search-image?query=Calendar%20with%20daily%20checkmarks%20beside%20a%20laptop%20showing%20product%20listings%2C%20consistency%20and%20updates%20concept%2C%20warm%20lighting%2C%20organized%20desk%2C%20neutral%20cream%20tones&width=600&height=400&seq=seo-card-v2-atualizado&orientation=landscape",
    title: "Hoobuy Spreadsheet Atualizado",
    subtitle: "Diariamente 2026",
  },
];

export default function SEOArticlesSection() {
  return (
    <section className="bg-foreground-900 py-16 md:py-24">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
          <div>
            <span className="inline-flex px-4 py-1.5 text-xs font-medium text-white border border-white/30 rounded-full whitespace-nowrap">
              Guia SEO
            </span>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mt-4">
              Artigos e Recursos
              <br />
              Hoobuy Sheet
            </h2>
          </div>
          <p className="text-sm text-white/50 max-w-xs">
            {articleCards.length} artigos com dicas, guias e análises sobre hoobuy spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {articleCards.map((card) => {
            const Wrapper = card.type === "internal" ? Link : "a";
            const wrapperProps =
              card.type === "internal"
                ? { to: card.to, className: "group bg-background-100 rounded-xl overflow-hidden transition-all cursor-pointer hover:-translate-y-1" }
                : {
                    href: card.href,
                    target: "_blank",
                    rel: "noopener nofollow",
                    className: "group bg-background-100 rounded-xl overflow-hidden transition-all cursor-pointer hover:-translate-y-1",
                  };

            return (
              <Wrapper key={card.title} {...wrapperProps}>
                <div className="w-full h-[200px] overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    title={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <p className="text-sm font-semibold text-foreground-900 leading-snug">
                    {card.title}
                  </p>
                  <p className="text-xs text-foreground-500 mt-2">
                    {card.subtitle}
                  </p>
                </div>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}